export default __webpack_public_path__ + "static/ultimate-548a2b4426feac7f76af717047ca4708.svg";